import React from "react";
import "./App.css";
import HomeScreen from "./HomeScreen";
import {
	BrowserRouter as Router,
	Switch,
	Route,
	useLocation,
} from "react-router-dom";
import AboutScreen from "./AboutScreen";
import ProjectScreen from "./ProjectScreen";
import ContactScreen from "./ContactScreen";
import { AnimatePresence } from "framer-motion";
import Navbar from "./Navbar";
//
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { faFacebook, faLinkedin } from "@fortawesome/free-brands-svg-icons";
library.add(fab, faFacebook, faLinkedin);

function App() {
	const location = useLocation();
	return (
		<div className="app" style={{ overflowX: "hidden" }}>
			<Navbar />
			{/* <Router> */}
			<AnimatePresence exitBeforeEnter>
				<Switch location={location} key={location.pathname}>
					<Route exact path="/" component={HomeScreen} />

					<Route path="/about" component={AboutScreen} />

					<Route path="/projects" component={ProjectScreen} />

					<Route path="/contact" component={ContactScreen} />
				</Switch>
			</AnimatePresence>
			{/* </Router> */}
		</div>
	);
}
export default App;
